import { render, staticRenderFns } from "./logs_formulario.vue?vue&type=template&id=25937057&"
import script from "./logs_formulario.vue?vue&type=script&lang=ts&"
export * from "./logs_formulario.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports